export default __webpack_public_path__ + "static/media/linkedin.032cf8a6.png";